var HoldingUiState = /** @class */ (function () {
    function HoldingUiState(search, filterState, sortStat, sum) {
        this.searchState = search;
        this.filterUiState = filterState;
        this.sortDataUiState = sortStat;
        this.isSummarize = sum;
    }
    return HoldingUiState;
}());
export { HoldingUiState };
